import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1dad283f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dad283f')) {
      api.createRecord('1dad283f', component.options)
    } else {
      api.reload('1dad283f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1dad283f&", function () {
      api.rerender('1dad283f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnpackgameInstanceItem/index.vue"
export default component.exports